import { render, staticRenderFns } from "./confirmRemove.vue?vue&type=template&id=4be4ad1e"
import script from "./confirmRemove.vue?vue&type=script&lang=js"
export * from "./confirmRemove.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports